import React from 'react';
import { TbBrandGithub }  from "react-icons/tb";
import { SiWhatsapp } from "react-icons/si";
import { FaGoogleDrive } from "react-icons/fa";
import { SlSocialYoutube, SlSocialLinkedin, SlSocialFacebook, SlSocialInstagram } from "react-icons/sl";

const socials = [
    {
        id: "01",
        name: "GitHub",
        url: "https://github.com/Bunmi194/",
        icon: <TbBrandGithub />
    },
    {
        id: "02",
        name: "WhatsApp",
        url: "https://api.whatsapp.com/send?phone=2347038250132",
        icon: <SiWhatsapp />
    },
    {
        id: "03",
        name: "LinkedIn",
        url: "https://www.linkedin.com/in/bunmi-oladipupo-34045a169/",
        icon: <SlSocialLinkedin />
    },
    {
        id: "04",
        name: "Google Drive",
        url: "https://drive.google.com/drive/folders/1iF5lSN40HCFqhHWPlNoGxhECKC5LmQM7?usp=sharing",
        icon: <FaGoogleDrive />
    },
]
const LeftSide = () => {
  return (
    <div className='w-full h-full flex flex-col items-center justify-end gap-4 text-textLight'>
        <div className='flex flex-col gap-4'>
            {
                socials && socials.map((social)=>{
                    return <a href={social.url} target="_blank" rel='noreferrer' className='cursor-pointer'>
                    <span className='w-10 h-10 text-xl bg-hoverColor rounded-full inline-flex items-center justify-center hover:text-textGreen cursor-pointer hover:-translate-y-2 transition-all duration-300'>
                        {social.icon}
                    </span>
                </a>
                    
                })
            }
        </div>
        <div className='w-[2px] h-32 bg-textDark'>

        </div>
    </div>
  )
}

export default LeftSide;